import './style.css'
import './bundled/style.css'
import { mountMainApp } from './bundled/index.js'

mountMainApp()
